<template>
  <el-dialog :title="'【' + modelParam.task_id + '】' + modelParam.describe" center class="devOps-modelNine"
    :visible.sync="dialogVisible" width="80%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" center :rules="rules" :model="form" label-width="160px">
      <el-form-item center>
        <el-button :loading="runLoading" type="warning" :disabled="nonStandard" @click="onSubmit('run')">执行检测</el-button>
        <el-button :loading="skipLoading" type="warning" @click="onSubmit('skip')">跳 过</el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi">查看历史</el-button>
        <el-button type="success" @click="handleClose">关 闭</el-button>
      </el-form-item>
    </el-form>
    <TableTwo v-if="tableDataTwo.length" :tableData="tableDataTwo" />
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <pre v-if="message" v-html="message" class="tips-message"></pre>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceListStageOutputApi,
} from "@/server/tops/devOps";

import { TableOne, TableTwo } from "../table/index";

export default {
  components: { TableOne, TableTwo },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {},
      rules: {},
      message: "",
      runLoading: false,
      skipLoading: false,
      tableData: [],
      tableDataTwo: [],
    };
  },
  computed:{
    nonStandard() { // 非标系统标识
      return this.modelParam.module_name.startsWith('非标-')
    }
  },
  async mounted() {
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  methods: {
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          this.form = ret.data;
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      const { stage_id = "", task_id = "" } = this.modelParam;
      this.tableDataTwo = [];
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      action === "skip" && (await this.queryActionSkipSubmit("skip"));
      action === "run" && (await this.queryActionRunSubmit("run"));
    },
    // 跳过接口调用
    async queryActionSkipSubmit(action) {
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
        tester: "",
      };
      try {
        this.skipLoading = true;
        const ret = await postDevopsSpaceStageActionApi(param);
        this.$notify({
          message: ret.status === "success" ? "跳过成功" : "跳过失败",
          type: ret.status === "success" ? "success" : "error",
        });
        ret.status === "success"
          ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
          : (this.message = JSON.stringify(ret.data || "", null, 2));
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.skipLoading = false;
      }
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.tableDataTwo = [];
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
      };
      this.runLoading = true;
      try {
        const ret = await postDevopsSpaceStageActionApi(param);
        let info = ret?.data?.output?.status[0] || {};
        this.$notify({
          message: info.code === 0 ? "检测成功" : "检测失败",
          type: info.code === 0 ? "success" : "error",
        });
        let module = Object.keys(info?.data)[0] || "";
        let moduleObj = info?.data[module] || {};

        this.tableDataTwo = [moduleObj];
      } catch (error) {
        this.tableDataTwo = [];
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.runLoading = false;
        this.tableData = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 240px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelNine {
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-form-item__content {
    display: flex;
    margin-left: 0 !important;
    justify-content: center;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>